import { Component } from '@angular/core';


@Component({
    selector: 'footer',
    templateUrl: 'footer.html'
})

export class FooterComponent {
    now = new Date();

    constructor() {

    }
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/components/footer/footer.ts